module.exports = __webpack_public_path__ + "img/img_2.eba93c0e.png";